"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Box_1 = require("@mui/material/Box");
var Card_1 = require("@mui/material/Card");
var material_1 = require("@mui/material");
var Fab_1 = require("@mui/material/Fab");
var Add_1 = require("@mui/icons-material/Add");
var TextareaAutosize_1 = require("@mui/base/TextareaAutosize");
var SuggestionService_1 = require("../services/SuggestionService");
var StorageKeys_1 = require("../shared/storage/StorageKeys");
var StorageService_1 = require("../shared/storage/StorageService");
var Toast_1 = require("../shared/utilities/Toast");
var CloudUpload_1 = require("@mui/icons-material/CloudUpload");
var StyledCard = styles_1.styled(Card_1.default)({
    color: 'darkslategray',
    backgroundColor: '#F3F3F3',
    marginBottom: 8,
    borderRadius: 4,
});
var ImageStyleLeft = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'left',
    padding: '10px'
};
var ImageStyleRight = {
    maxHeight: '33vh',
    maxWidth: '33vw',
    width: 'auto',
    height: 'auto',
    float: 'right',
    padding: '10px'
};
//TODO: make this global
var DrawerHeader = styles_1.styled("div")(function (_a) {
    var theme = _a.theme;
    return (__assign({ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: theme.spacing(0, 1) }, theme.mixins.toolbar));
});
var blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};
var grey = {
    50: '#f6f8fa',
    100: '#eaeef2',
    200: '#d0d7de',
    300: '#afb8c1',
    400: '#8c959f',
    500: '#6e7781',
    600: '#57606a',
    700: '#424a53',
    800: '#32383f',
    900: '#24292f',
};
var Textarea = styles_1.styled(TextareaAutosize_1.TextareaAutosize)(function (_a) {
    var theme = _a.theme;
    return "\n    width: 100%;\n    font-family: IBM Plex Sans, sans-serif;\n    font-size: 0.875rem;\n    font-weight: 400;\n    resize: none;\n    line-height: 1.5;\n    padding: 12px;\n    border-radius: 12px 12px 0 12px;\n    color: " + (theme.palette.mode === 'dark' ? grey[300] : grey[900]) + ";\n    background: " + (theme.palette.mode === 'dark' ? grey[900] : '#fff') + ";\n    border: 1px solid " + (theme.palette.mode === 'dark' ? grey[700] : grey[200]) + ";\n    box-shadow: 0px 2px 2px " + (theme.palette.mode === 'dark' ? grey[900] : grey[50]) + ";\n\n    &:hover {\n      border-color: " + blue[400] + ";\n    }\n\n    &:focus {\n      border-color: " + blue[400] + ";\n      box-shadow: 0 0 0 3px " + (theme.palette.mode === 'dark' ? blue[500] : blue[200]) + ";\n    }\n\n    // firefox\n    &:focus-visible {\n      outline: 0;\n    }\n  ";
});
var VisuallyHiddenInput = styles_1.styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
function AddSuggestion() {
    var _this = this;
    var _a = React.useState(false), isInvalid = _a[0], setIsInvalid = _a[1];
    var _b = React.useState(true), ready = _b[0], setReady = _b[1];
    var _c = React.useState(''), subject = _c[0], setSubject = _c[1];
    var _d = React.useState(''), description = _d[0], setDescription = _d[1];
    var _e = Toast_1.default(), showErrorMessage = _e.showErrorMessage, showSuccessMessage = _e.showSuccessMessage;
    var _f = React.useState(''), fileUrl = _f[0], setFileUrl = _f[1];
    var _g = React.useState(undefined), file = _g[0], setFile = _g[1];
    var handleAddSuggestion = function () { return __awaiter(_this, void 0, void 0, function () {
        var userId, _a, reader_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (subject.trim() === '' || description.trim() === '') {
                        showErrorMessage('Suggestion information is invalid!');
                        setIsInvalid(true);
                        return [2 /*return*/];
                    }
                    _a = Number;
                    return [4 /*yield*/, StorageService_1.default.get(StorageKeys_1.Auth.Id)];
                case 1:
                    userId = _a.apply(void 0, [_b.sent()]);
                    setReady(false);
                    if (file != undefined) {
                        reader_1 = new FileReader();
                        reader_1.readAsDataURL(file);
                        reader_1.onload = function () {
                            if (reader_1.result != null) {
                                handleCreateSuggestion(userId, subject, description, file.name, reader_1.result.toString().split('base64,')[1]);
                            }
                        };
                        reader_1.onerror = function (error) {
                            console.log('Error: ', error);
                        };
                    }
                    else {
                        handleCreateSuggestion(userId, subject, description, null, null);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); };
    var handleCreateSuggestion = function (userId, subject, description, documentName, documentBytes) {
        SuggestionService_1.default.CreateSuggestion(userId, subject, description, documentName, documentBytes).then(function (response) {
            if (response !== undefined) {
                showSuccessMessage('Suggestion added successfully!');
                setSubject('');
                setDescription('');
                setFile(undefined);
                setFileUrl('');
            }
            else {
                showErrorMessage('Error occured adding suggestion');
            }
            setReady(true);
        });
    };
    var handleSubjectChange = function (e) {
        setSubject(e.target.value);
    };
    var handleDescriptionChange = function (e) {
        setDescription(e.target.value);
    };
    var handleFileChange = function (e) {
        var file = e.target.files[0];
        setFileUrl(URL.createObjectURL(file));
        setFile(file);
    };
    return (React.createElement(Box_1.default, { component: "main", sx: { flexGrow: 1, p: 3 } },
        React.createElement(DrawerHeader, null),
        !ready &&
            React.createElement("div", { style: { display: 'flex', alignItems: 'center', justifyContent: 'center' } },
                React.createElement(material_1.CircularProgress, { size: 100, disableShrink: true })),
        ready &&
            React.createElement(React.Fragment, null,
                React.createElement(material_1.TextField, { fullWidth: true, "aria-label": "minimum height", minRows: 1, maxRows: 1, placeholder: "Subject", onChange: handleSubjectChange, value: subject, error: isInvalid && subject === "", helperText: isInvalid && subject === "" ? 'Suggestion subject is required' : '' }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(material_1.TextField, { multiline: true, fullWidth: true, rows: 8, "aria-label": "minimum height", minRows: 8, placeholder: "Add your suggestion here!", onChange: handleDescriptionChange, value: description, error: isInvalid && description === "", helperText: isInvalid && description === "" ? 'Suggestion description is required' : '' }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement(material_1.Button, { component: "label", variant: "contained", startIcon: React.createElement(CloudUpload_1.default, null) },
                    "Upload",
                    React.createElement(VisuallyHiddenInput, { type: "file", onChange: handleFileChange })),
                React.createElement("br", null),
                fileUrl !== '' && fileUrl !== null &&
                    React.createElement("a", { href: fileUrl, download: true }, "View"),
                React.createElement("br", null),
                React.createElement(Fab_1.default, { color: "primary", style: { float: 'right' }, variant: "extended", onClick: handleAddSuggestion },
                    React.createElement(Add_1.default, null),
                    " Add Suggestion"))));
}
exports.default = AddSuggestion;
//# sourceMappingURL=AddSuggestion.js.map